import React, { useEffect, useState } from 'react';
import { Button, Table, Typography, Space, Popconfirm } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import AxiosCaller from '../../../../authenticatie/AxiosCaller';
import { Trash2, Pencil } from 'lucide-react';
import { openNotificationSuccess, openNotificationError } from '../../../../Components/Notification/Notification';

const { Title } = Typography;

const LeverancierOverzichtScreen = () => {
  const { get, del } = AxiosCaller();
  const [leveranciers, setLeveranciers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchLeveranciers();
  }, []);

  const fetchLeveranciers = async () => {
    try {
      const response = await get('/leverancier');
      const sortedLeveranciers = response.data.sort((a, b) => a.naam.localeCompare(b.naam));
      setLeveranciers(sortedLeveranciers);
    } catch (error) {
      console.error(error)
      openNotificationError("Fout bij ophalen van leveranciers", error)
    }
  };

  const handleRemove = async (record) => {
    try {
      await del(`/leverancier/${record._id}`);
      openNotificationSuccess("Leverancier succesvol verwijderd")
     await fetchLeveranciers()
    } catch (error) {
     console.error(error)
     openNotificationError("Fout bij verwijderen van leverancier", error)
    }
  };

  const handleEdit = (record) => {
    navigate('/Admin/configuratie/MakenAanpassenLeverancier', { state: record });
  };

  const columns = [
    {
      title: 'Naam',
      dataIndex: 'naam',
      sorter: (a, b) => a.naam.localeCompare(b.naam),
      
    },
    {
      title: 'Acties',
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            icon={<Pencil style={{ color: 'var(--primary-color)', fontSize: '18px' }} />}
            onClick={() => handleEdit(record)}
            style={{ fontSize: '18px' }}
          />
          <Popconfirm
            title={`Weet je zeker dat je '${record.naam}' wilt verwijderen?`}
            onConfirm={() => handleRemove(record)}
            okText="Ja"
            cancelText="Nee"
          >
            <Trash2 className="delete-button" style={{ fontSize: '18px', color: 'var(--primary-color)' }} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div className="Screen-container">
      <div className="space-between">
        <h1 className="title">Leveranciers</h1>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => navigate('/Admin/configuratie/MakenAanpassenLeverancier')}
          className="button"
        >
          Nieuwe Leverancier
        </Button>
      </div>

      <Table
        dataSource={leveranciers.map((lev) => ({ ...lev, key: lev._id }))}
        columns={columns}
        pagination={false}
        rowClassName={(record, index) => (index % 2 === 0 ? 'custom-table-row-even' : 'custom-table-row-odd')}
        bordered
        scroll={{ y: 0.5 * window.innerHeight }}
      />
    </div>
  );
};

export default LeverancierOverzichtScreen;